var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.9 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,5.2a4.48,4.48,0,0,0,1.9-2.4,9.87,9.87,0,0,1-2.7,1,4,4,0,0,0-3.1-1.3A4.16,4.16,0,0,0,12,3.8a4.34,4.34,0,0,0-1.3,3,3.08,3.08,0,0,0,.1,1A11.92,11.92,0,0,1,2,3.3a4.2,4.2,0,0,0-.6,2.1A4.13,4.13,0,0,0,3.3,9a3.83,3.83,0,0,1-1.9-.5,4,4,0,0,0,1,2.8,4.94,4.94,0,0,0,2.4,1.5,4.1,4.1,0,0,1-1.1.1,1.72,1.72,0,0,1-.8-.1,4.08,4.08,0,0,0,1.5,2.1,4.47,4.47,0,0,0,2.5.9,8.49,8.49,0,0,1-5.3,1.8H.5a11.82,11.82,0,0,0,6.6,1.9,11.37,11.37,0,0,0,6.6-1.9A12.21,12.21,0,0,0,17.9,13a12.63,12.63,0,0,0,1.4-5.7V6.7a8.65,8.65,0,0,0,2.1-2.2A8.43,8.43,0,0,1,19,5.2Z",
    transform: "translate(-0.5 -2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ffa6fcac50371a9bf677707ccbe5410c.svg";
export { ForwardRef as ReactComponent };